module.exports = __webpack_public_path__ + "static/media/sms-dark.93bcca5c.png";